export default __webpack_public_path__ + "static/media/greendot.c1b2dd6d.svg";